import React, {ChangeEvent, useEffect, useState, useContext, useRef} from 'react';
import { List, Avatar, Input, Badge, Modal, Menu, Dropdown, message, Checkbox } from 'antd';
import { EllipsisOutlined, SearchOutlined } from '@ant-design/icons';
import styles from './ContactList.module.css';
import axios from 'axios';
//import {debounce} from 'lodash';
import { HubConnectionState } from '@microsoft/signalr';
//const signalR = require('@microsoft/signalr');
import * as signalR from '@microsoft/signalr';
import {jwtDecode} from 'jwt-decode';
import { SignalRContext } from '../../contexts/SignalRContext';
const contacts = [
  {groupId: 0, email: 'abc@gmail.com', name: 'Tuan Vu', avatar: 'link_to_avatar', online: true, isGroup:false, unReadCount:0 },
  {groupId: 0, email: 'abc@gmail.com', name: 'Nguyễn Văn Huy', avatar: 'link_to_avatar', online: true, isGroup:false, unReadCount:0 },
  {groupId: 0, email: 'abc@gmail.com', name: 'Lao Hac', avatar: 'link_to_avatar', online: true, isGroup:false, unReadCount:0 },
  {groupId: 0, email: 'abc@gmail.com', name: 'Lý Thanh Thanh', avatar: 'link_to_avatar', online: true, isGroup:false, unReadCount:0 },
];
interface ContactListProp {
    handleChangeGroupId: (id: number, createdUser:string, groupArr: {userName: string, email: string, userAvatar: string, isGroup:boolean}[]
    ) => void
}
interface JwtPayload {
  exp: number; // expiration timestamp (in seconds)
  iat?: number;
  sub?: string;
  [key: string]: any;
}
const ContactList = (props: ContactListProp) => {
  const userId = localStorage.getItem('emailData');
  const usersAdded = useRef([localStorage.getItem('emailData')]);
  const token = localStorage.getItem('token'); 
  const [avatar, setAvatar] = useState(localStorage.getItem('avatar')??'');
  const [groupName, setGroupName] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalGroupOpen, setIsModalGroupOpen] = useState(false);
  const [newPass, setNewPass] = useState('');
  const [isModalPassOpen, setIsModalPassOpen] = useState(false);
    const [listUser, setListUser] = useState(contacts);
    const [usersDisplay, setUserDisplay] = useState<any>([]);
    const [fileList, setFileList] = useState<File>();
    const signalContext = useContext(SignalRContext);
    const connection = signalContext?.connection;  
    useEffect(() => {
      if(connection){
        connection.on("ReceiveSignal", (groupId:string)=>{
          setUserDisplay((prevList:any) => {
            const index = prevList.findIndex((x:any) => x.groupId === Number(groupId));
            if (index > -1) {
              const updatedUser = { ...prevList[index], unReadCount: prevList[index].unReadCount + 1 };
              return [
                ...prevList.slice(0, index),
                updatedUser,
                ...prevList.slice(index + 1)
              ];
            }
            return prevList;
          });
        })
        connection.on("ReceiveSeenStatus", (messageId: number, email:string, groupId:string)=>{
          setUserDisplay((prevList:any) => {
            const index = prevList.findIndex((x:any) => x.groupId === Number(groupId));
            if (index > -1 && email == localStorage.getItem('emailData')) {
              const updatedUser = { ...prevList[index], 
                unReadCount: prevList[index].unReadCount - 1 < 0 ? 0 : prevList[index].unReadCount - 1 };
              return [
                ...prevList.slice(0, index),
                updatedUser,
                ...prevList.slice(index + 1)
              ];
            }
            return prevList;
          });
        })
          connection.on("ReceivedOnline", (userId:string, status:boolean) => {
            setUserDisplay((pre:any) => {
              const index = pre.findIndex((x:any) => x.email === userId);
              if (index > -1) {
                const updatedUser = { ...pre[index], online: status };
                return [
                  ...pre.slice(0, index),
                  updatedUser,
                  ...pre.slice(index + 1)
                ];
              }
              return pre;
            });
          });
          connection.on("logoutRequest", (logout:boolean)=>{
              if(logout)
              {
                message.info('Bạn đăng nhập trên thiết bị khác');
                localStorage.clear();
                connection.stop();
                window.location.reload();
              }
          })
          connection.on("ReceivedOffline", (userId:string, status:boolean) => {
            setUserDisplay((pre:any) => {
              const index = pre.findIndex((x:any) => x.email === userId);
              if (index > -1) {
                const updatedUser = { ...pre[index], online: status };
                return [
                  ...pre.slice(0, index),
                  updatedUser,
                  ...pre.slice(index + 1)
                ];
              }
              return pre;
            });
          });
      }
      const decoded = jwtDecode<JwtPayload>(token??'');
const expiresInMs = decoded.exp * 1000 - Date.now();
if (expiresInMs > 5000) {
  setTimeout(() => {
    connection?.stop(); // this will NOT trigger a 401
  }, expiresInMs - 5000);
}
    }, []);
  const handleAddingGroup = async ()=>{
    if(usersAdded.current.length>=3){
        const response = await fetch(process.env.REACT_APP_API_URL_FOR_CHAT+'api/GroupUser', {
          method:'POST',
          headers: {
            'Content-Type':'application/json',
            'Authorization':`Bearer ${token}`
          },
          body: JSON.stringify({
  id: 0,
  groupName: groupName,
  createdDate: "2025-06-11T02:47:45.906Z",
  updatedDate: "2025-06-11T02:47:45.906Z",
  createdUser: localStorage.getItem('emailData'),
  groupUsers: [...usersAdded.current.map((item:any)=>{
      return {
      id: 0,
      email: item,
      addedDate: "2025-06-11T02:47:45.906Z",
      addedUser: localStorage.getItem('emailData')
     }
  })]
})
        });
    if(!response.ok) alert('Thêm nhóm mới thất bại');
    else{
        let data = await response.json();
        if(data.groupId > 0)
        {
            usersAdded.current.splice(1, usersAdded.current.length-1);
            setUserDisplay((prev:any)=>[...prev, {
      groupId: data.groupId,
      email: data.groupId,
      createdUser: data.createdUser,
      name: groupName,
      avatar: null,
      online: false,
      isGroup: true,
      unReadCount: 0
            }]);
        }
    }
    setIsModalGroupOpen(false);
  }
  else{
      alert("Phải chọn ít nhất 2 tài khoản để thêm vào nhóm");
  }
  }
  const getUser = async () => {
  const myOption = localStorage.getItem('roleData') === '3';
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL_FOR_CHAT}api/User/${localStorage.getItem('emailData')}/${true}`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorized': `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        // Unauthorized → clear and reload
        localStorage.clear();
        //connection?.stop();
        window.location.reload();
      } else {
        // Optional: Handle other HTTP errors here
        console.warn("Unexpected HTTP status:", response.status);
      }
      return; // stop execution
    }
    else{
        let data;
    try {
      data = await response.json();
    } catch (jsonErr) {
      console.error("Failed to parse JSON:", jsonErr);
      return;
    }

    if (!Array.isArray(data)) {
      console.warn("Unexpected data format:", data);
      return;
    }
    const formatted = data.map((item: any) => ({
      groupId: item.groupId,
      email: item.email,
      createdUser: item.createdUser,
      name: item.fullName,
      avatar: item.imageData,
      online: item.isActive,
      isGroup: item.isGroup,
      unReadCount: item.unReadCount,
    }));

    setListUser(formatted);
    setUserDisplay(formatted);
    }
    } catch (networkErr) {
    console.error("Fetch failed:", networkErr);
    // Optional: Show toast or alert for offline/user experience
  }
};
    const menu = (
      <Menu>
        <Menu.Item key="new-group" onClick={() => setIsModalGroupOpen(true)}>
          Tạo nhóm mới
        </Menu.Item>
        <Menu.Item key="change-password" onClick={() => setIsModalPassOpen(true)}>
          Change Password
        </Menu.Item>
      </Menu>
    );
    useEffect(()=>{
        getUser();
    },[])
    const handleUserSelect = (email:string, userSelected:string, userAvatar: string, isGroup:boolean, createdUser:string) => {     
      fetch(process.env.REACT_APP_API_URL_FOR_CHAT+'api/GroupUser/' + userId + "/" + email, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
      }).then(async(response)=>{
          if (!response.ok) {
                if (response.status === 401) {
                    localStorage.clear();
                    connection?.stop();
                    window.location.reload();
                }
                return null; // <=== Explicitly return a safe value
            }
          else{
              try {
                return await response.json();
            } catch (err) {
                    console.error("Invalid JSON in response");
                    return null;
            }
          }
      })
      .then(data=>{
        let sessionUser = listUser.filter((x:any)=>x.email == localStorage.getItem('emailData'))[0]?.name ?? '';
        let sessionEmail = listUser.filter((x:any)=>x.email == localStorage.getItem('emailData'))[0]?.email??'';
        let sessionAvatar = listUser.filter((x:any)=>x.email == localStorage.getItem('emailData'))[0]?.avatar??'';
        props.handleChangeGroupId(Number(data),  createdUser, 
        [{userName:userSelected, email:email, userAvatar:userAvatar, isGroup:isGroup}, 
          {userName:sessionUser, email:sessionEmail, userAvatar:sessionAvatar, isGroup: false}])
        })
        .catch(error=>console.log(error))   
    }
  return (
    <div className={styles.contactlist}>
      <div className={styles.header}>
        <a href='#' onClick={()=>{
          setIsModalOpen(true);
        }}>
          <Avatar style={{width:'80px', height:'80px', marginRight:'20px'}} src={localStorage.getItem('avatar') || null} />
        </a>
          <h3>{localStorage.getItem('userFullName')}</h3>
      </div>
      <div className={styles.header}>
        <button onClick={async ()=>{
          if(connection?.state == HubConnectionState.Connected){
            connection.stop();
          }
          localStorage.clear();
          window.location.reload();
        }}>Log out</button>
        <div className={styles.headeractions}>
          <Input placeholder="Search" prefix={<SearchOutlined />} 
          onKeyUp={(e:any)=>{
            if(e.key == 'Enter'){
              setUserDisplay(listUser.filter(x=>x.name.includes(e.currentTarget.value)))
          }}}
          />
          <Dropdown overlay={menu} trigger={["hover"]}>
            <EllipsisOutlined className={styles.ellipsisicon} style={{cursor:'pointer'}} />
          </Dropdown>
        </div>
      </div>
      <div className={styles.fullHeightList}>
      <List
        itemLayout="horizontal"
        dataSource={usersDisplay}
        renderItem={(user:any) => (
          <List.Item>
            <List.Item.Meta
              avatar={<Avatar src={user.avatar || null} />}
              title={<a onClick={()=>{
                //alert(user.email);
                handleUserSelect(user.email, user.name, user.avatar, user.isGroup, user.createdUser)
                }}>
              {user.name}&nbsp;&nbsp;{user.online == true ? <span className={styles.onlinestatus}></span>
            :user.online == null ? <span className={styles.idlestatus}></span>:null}</a>}
            />
            <div className="extra-info">
              <Badge count={user.unReadCount} showZero={false} className="unread-count" />
            </div>            
          </List.Item>
        )}
      />
      </div>
      <Modal title="Thay đổi ảnh đại diện" 
            open={isModalOpen} onOk={()=>{
                const token = localStorage.getItem('token');
                const formData = new FormData();
                if(fileList)
                {
                    formData.append("ImageData", fileList);      
            const config = {     
              headers: { 'content-type': 'multipart/form-data', 'Authorization': `Bearer ${token}` }
            }
             axios.put(process.env.REACT_APP_API_URL_FOR_CHAT+'api/User/'+ localStorage.getItem('emailData'), formData, config)
              .then(response => {
                localStorage.setItem('avatar', response.data.imageData);
                setAvatar(response.data.imageData);
              })
              .catch(error => {
                  console.log(error);
              });
            setIsModalOpen(false);      
          }}}
            onCancel={()=>setIsModalOpen(false)} >
                Chọn ảnh: <Input type="file" onChange={(e:ChangeEvent<HTMLInputElement>)=>{
          const temp = e.target.files;
          if(!temp) 
            return;
          else
            setFileList(temp[0])}} />
          </Modal>
          <Modal title="Thay đổi mật khẩu" 
            open={isModalPassOpen} onOk={()=>{
                const token = localStorage.getItem('token');
                const formData = new FormData();
                if(newPass != ''){
                    formData.append("Password", newPass);      
            const config = {     
              headers: { 'content-type': 'multipart/form-data', 'Authorization': `Bearer ${token}` }
            }
             axios.put(process.env.REACT_APP_API_URL_FOR_CHAT+'api/User/'+ localStorage.getItem('emailData'), formData, config)
              .then(response => {
                if(response.status == 200)
                  message.info(response.data.message);
              })
              .catch(error => {
                  console.log(error);
              });
            setIsModalPassOpen(false);      
          }}}
            onCancel={()=>setIsModalPassOpen(false)} >
                Mật khẩu mới: <Input type="password" onChange={(e:any)=>{
            setNewPass(e.currentTarget.value);
          }} />
          </Modal>
          <Modal
  title="Thêm nhóm mới"
  open={isModalGroupOpen}
  onCancel={()=>setIsModalGroupOpen(false)}
  onOk={handleAddingGroup}
  width={400}  // Set a fixed width
  style={{ top: 50 }} // Position the modal nicely
  bodyStyle={{ height: 500, padding: 0 }} // Set height and remove padding
>
  Nhập tên nhóm: <Input size="large" placeholder="large size" 
      onChange={(e)=>setGroupName(e.currentTarget.value)}
  />
  <List style={{width:'100%'}}
        itemLayout="horizontal"
        dataSource={usersDisplay.filter((x:any)=>x.isGroup==false)}
        renderItem={(user:any) => (
          <List.Item>
            <List.Item.Meta
              avatar={<Avatar src={user.avatar || null} />}
              title={<div><Checkbox onChange={(e)=>{
                  if(e.target.checked)
                        usersAdded.current.push(user.email)
                  else
                        usersAdded.current.splice(usersAdded.current.indexOf(user.email),1);
              }} />&nbsp;&nbsp;<a>
              {user.name}&nbsp;&nbsp;{user.online == true ? <span className={styles.onlinestatus}></span>
            :user.online == null ? <span className={styles.idlestatus}></span>:null}</a></div>}
            />           
          </List.Item>)}
  />
</Modal>
    </div>
  );
};
export default ContactList;
